'use client';

import { PortableTextMarkComponentProps } from '@portabletext/react';
import { textAlignment } from '@stereoagency/sanity-schema';
import { twMerge } from '@stereoagency/tailwind-config';

export default function TextAlignmentAnnotationComponent({
  value,
  children
}: PortableTextMarkComponentProps<typeof textAlignment.schema.textAlignment>) {
  return (
    <span
      className={twMerge(
        'text-left first-of-type:last-of-type:block',
        value?.alignment === 'center' && 'text-center',
        value?.alignment === 'right' && 'text-right'
      )}
    >
      {children}
    </span>
  );
}
